import { SizeClass, useSizeClass } from '@omni/kit/contexts/SizeClassContext';
import { StyleSheet, View } from 'react-native';

import BorderRadius from '@omni/kit/theming/BorderRadius';
import { BridgeAction } from '@omni/kit/Types';
import Colors from '@omni/kit/theming/Colors';
import { IBlockProps } from './types';
import KitIcon from '@omni/kit/components/KitIcon';
import KitListItem from '@omni/kit/components/KitListItem';
import KitText from '@omni/kit/components/KitText';
import React from 'react';
import Spacing from '@omni/kit/theming/Spacing';
import { dispatch } from '@omni/kit/ActionHandler';
import { useScreenContext } from '@omni/kit/contexts/ScreenContext';
import { useTranslation } from 'react-i18next';

const debug = require('debug')('tca:blocks:GivingBlock');

export interface GivingBlockProps extends IBlockProps {
  /** An action that will occur when a user taps/clicks on the block. */
  action?: BridgeAction | null;
}

export default function GivingBlock({
  action,
}: GivingBlockProps): JSX.Element | null {
  const { t } = useTranslation(['giving']);
  const { sizeClass } = useSizeClass();
  const addSpacing = sizeClass !== SizeClass.Small;
  const { edgeSpacing, viewPortWidth } = useScreenContext({
    fixedSpacingType: undefined,
  });

  const renderGivingIcon = () => {
    return (
      <View style={styles.givingIcon}>
        <KitIcon color={Colors.N300} name={'dollar'} size={20} />
      </View>
    );
  };

  return (
    <View
      style={[
        styles.container,
        {
          paddingHorizontal: addSpacing ? edgeSpacing : 0,
        },
      ]}
    >
      <View style={styles.titleWrapper}>
        <View style={styles.titleContainer}>
          <KitText h2 bold={true} color={Colors.N900}>
            {t('giving:headerTitle')}
          </KitText>
        </View>
      </View>
      <View style={{ paddingHorizontal: Spacing.l }}>
        <KitListItem
          bottomBorder={false}
          ImageComponent={renderGivingIcon()}
          showRightIconOnAndroid={true}
          style={styles.givingListItem}
          title={t('giving:accountMenuItemTitle')}
          subtitle={t('giving:accountMenuItemSubtitle')}
          titleColor={Colors.N900}
          titleFontSize={16}
          onPress={() => dispatch(action)}
          onPressUnderlayColor={Colors.N50}
        />
      </View>
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    marginTop: Spacing.xxl,
  },
  titleWrapper: {
    marginBottom: Spacing.m,
    paddingHorizontal: Spacing.l,
  },
  titleContainer: {
    alignItems: 'center',
    display: 'flex',
    flexDirection: 'row',
  },
  givingListItem: {
    borderColor: Colors.N100,
    borderRadius: BorderRadius.l,
    borderWidth: 1,
    paddingHorizontal: Spacing.l,
    paddingVertical: Spacing.m,
  },
  givingIcon: {
    alignItems: 'center',
    backgroundColor: Colors.N50,
    borderRadius: BorderRadius.m,
    display: 'flex',
    justifyContent: 'center',
    padding: Spacing.s,
  },
});
